<template>
  <v-select
    outlined
    label="Week Days"
    :items="items"
    :multiple="multiple"
    :value="value"
    @input="update"
    ref="selectComponent"
  >
    <template v-slot:prepend-item v-if="multiple">
      <v-list-item
        ripple
        @click="selectAll"
      >
        <v-list-item-action>
          <v-icon :color="value && value.length > 0 ? 'primary' : ''">{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select All</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      default () {
        if (this.multiple) {
          return []
        }
        return null
      }
    }
  },
  data () {
    return {
      items: days.map((v, index) => ({ text: v, value: index + '' }))
    }
  },
  computed: {
    selectAllIcon () {
      if (!this.multiple) {
        return
      }
      if (this.value && this.value.length === this.items.length) {
        return 'fa-check-square'
      } else if (this.value && this.value.length) {
        return 'fa-minus-square'
      }
      return 'fa-square'
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    },
    selectAll () {
      if (this.value && this.value.length) {
        this.update([])
      } else {
        this.update(this.items.map(m => m.value))
        this.$refs.selectComponent.blur()
      }
    }
  }
}
</script>
